import { render, staticRenderFns } from "./SuccessfulOnsiteSubmissionView.vue?vue&type=template&id=533d8594"
import script from "./SuccessfulOnsiteSubmissionView.vue?vue&type=script&lang=js"
export * from "./SuccessfulOnsiteSubmissionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports